module.exports = __webpack_public_path__ + "static/matthew_an_2020-e18a77cdf6a60bf4e851938debeeb9c0.pdf";